import { getCurrentInstance } from 'vue'

export default function useAxios() {
  const internalInstance = getCurrentInstance()
  const $axios = internalInstance.appContext.config.globalProperties.$axios

  return $axios
}
